import { motion } from "framer-motion";

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export function Reveal({ children, className = "", delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ children, className = "" }) {
  return (
    <div className={`overline ${className}`}>{children}</div>
  );
}

export function SectionTitle({ children, className = "" }) {
  return (
    <h2 className={`font-serif text-3xl md:text-5xl tracking-tight leading-[1.1] text-slate-900 ${className}`}>
      {children}
    </h2>
  );
}
